"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import UserPageStatsTagsSet from "./UserPageStatsTagsSet";
import { formatNumberWithCommasOrDash } from "@/helpers/Helpers";
import { OwnerBalance, OwnerBalanceMemes } from "@/entities/IBalances";
import { MemeSeason } from "@/entities/ISeason";
export interface UserPageStatsTag {
  readonly id: string;
  readonly title: string;
  readonly classes: string;
}
export default function UserPageStatsTags(t0) {
  const $ = _c(22);
  const {
    ownerBalance,
    balanceMemes
  } = t0;
  let t1;
  if ($[0] !== ownerBalance) {
    t1 = () => {
      const result = [];
      if (!ownerBalance) {
        return result;
      }
      if (ownerBalance.nextgen_balance) {
        result.push({
          id: "nextgen",
          title: `NextGen x${formatNumberWithCommasOrDash(ownerBalance.nextgen_balance)}`,
          classes: "tw-whitespace-nowrap tw-inline-flex tw-items-center tw-rounded-full tw-bg-iron-400/10 tw-px-2 tw-py-1 tw-text-sm tw-font-medium tw-text-iron-300 tw-ring-1 tw-ring-inset tw-ring-iron-400/20"
        });
      }
      if (ownerBalance.memes_cards_sets) {
        result.push({
          id: "memes_sets",
          title: `Meme Sets x${formatNumberWithCommasOrDash(ownerBalance.memes_cards_sets)}`,
          classes: "tw-whitespace-nowrap tw-inline-flex tw-items-center tw-rounded-full tw-bg-iron-400/10 tw-px-2 tw-py-1 tw-text-sm tw-font-medium tw-text-iron-300 tw-ring-1 tw-ring-inset tw-ring-iron-400/20"
        });
      }
      if (ownerBalance.memes_balance) {
        result.push({
          id: "memes",
          title: `Memes x${formatNumberWithCommasOrDash(ownerBalance.memes_balance)} ${ownerBalance.unique_memes === ownerBalance.memes_balance ? "" : `(unique x${formatNumberWithCommasOrDash(ownerBalance.unique_memes)})`}`,
          classes: "tw-whitespace-nowrap tw-inline-flex tw-items-center tw-rounded-full tw-bg-iron-400/10 tw-px-2 tw-py-1 tw-text-sm tw-font-medium tw-text-iron-300 tw-ring-1 tw-ring-inset tw-ring-iron-400/20"
        });
      }
      if (ownerBalance.gradients_balance) {
        result.push({
          id: "gradients",
          title: `Gradients x${formatNumberWithCommasOrDash(ownerBalance.gradients_balance)}`,
          classes: "tw-whitespace-nowrap tw-inline-flex tw-items-center tw-rounded-full tw-bg-iron-400/10 tw-px-2 tw-py-1 tw-text-sm tw-font-medium tw-text-iron-300 tw-ring-1 tw-ring-inset tw-ring-iron-400/20"
        });
      }
      if (ownerBalance.boost) {
        result.push({
          id: "boost",
          title: `Boost x${formatNumberWithCommasOrDash(ownerBalance.boost)}`,
          classes: "tw-whitespace-nowrap tw-inline-flex tw-items-center tw-rounded-full tw-bg-iron-400/10 tw-px-2 tw-py-1 tw-text-sm tw-font-medium tw-text-iron-300 tw-ring-1 tw-ring-inset tw-ring-iron-400/20"
        });
      }
      return result;
    };
    $[0] = ownerBalance;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getMainTags = t1;
  let t2;
  if ($[2] !== balanceMemes) {
    t2 = () => {
      const result_0 = [];
      if (!balanceMemes.length) {
        return result_0;
      }
      for (const balance of balanceMemes) {
        if (balance.sets > 0 && balance.season) {
          result_0.push({
            id: balance.season.toString(),
            title: `SZN${balance.season} Sets x${formatNumberWithCommasOrDash(balance.sets)}`,
            classes: "w-whitespace-nowrap tw-inline-flex tw-items-center tw-rounded-full tw-px-2 tw-py-1 tw-text-sm tw-font-medium tw-ring-1 tw-ring-inset tw-bg-[#B884FF]/10 tw-text-[#B884FF] tw-ring-[#B884FF]/20"
          });
        }
      }
      return result_0;
    };
    $[2] = balanceMemes;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const getSeasonTags = t2;
  let t3;
  if ($[4] !== getMainTags) {
    t3 = getMainTags();
    $[4] = getMainTags;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const mainTags = t3;
  let t4;
  if ($[6] !== getSeasonTags) {
    t4 = getSeasonTags();
    $[6] = getSeasonTags;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const seasonTags = t4;
  const [haveAnyTags, setHaveAnyTags] = useState(!!mainTags.length || !!seasonTags.length);
  let t5;
  if ($[8] !== mainTags.length || $[9] !== seasonTags) {
    t5 = () => {
      setHaveAnyTags(!!mainTags.length || !!seasonTags.length);
    };
    $[8] = mainTags.length;
    $[9] = seasonTags;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== mainTags || $[12] !== seasonTags) {
    t6 = [mainTags, seasonTags];
    $[11] = mainTags;
    $[12] = seasonTags;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  useEffect(t5, t6);
  if (!haveAnyTags) {
    let t7;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <div />;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    return t7;
  }
  let t7;
  if ($[15] !== mainTags) {
    t7 = <UserPageStatsTagsSet tags={mainTags} />;
    $[15] = mainTags;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== seasonTags) {
    t8 = <UserPageStatsTagsSet tags={seasonTags} />;
    $[17] = seasonTags;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t7 || $[20] !== t8) {
    t9 = <div className="tw-space-y-2 sm:tw-space-y-3">{t7}{t8}</div>;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}